import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

const Footer = styled.footer`
  display: grid;
  justify-items: center;
`;

const Links = styled.div`
  gap: 13px;
  width: 100%;
  font-size: 12px;
  line-height: 16px;
  text-align: center;

  a {
    color: black;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Divider = styled.span`
  color: black;
`;

interface LegalLinksProps {
  termsHref?: string;
  privacyHref?: string;
}

export function LegalLinks({
  termsHref = '/policy/terms',
  privacyHref = '/policy/privacy',
}: LegalLinksProps) {
  return (
    <Footer>
      <Links>
        <Link to={termsHref}>Terms of Use</Link>
        <Divider> and </Divider>
        <Link to={privacyHref}>Privacy Policy</Link>
      </Links>
    </Footer>
  );
}
